const TERMINAL_GATEWAY_INVENTORY_STATUSES = new Set([
    'returned',
    'retired',
]);
export function buildTenantEfemGatewayStatusMap(devices) {
    const map = new Map();
    for (const device of devices) {
        if (device.deviceCategory === 'efem-gateway') {
            map.set(device.serialNumber, device.inventoryStatus);
        }
    }
    return map;
}
export function isEfemParentGatewayBindingStale(parentGatewaySerial, tenantGatewayStatusBySerial) {
    if (!parentGatewaySerial)
        return false;
    if (!tenantGatewayStatusBySerial.has(parentGatewaySerial)) {
        return true;
    }
    const status = tenantGatewayStatusBySerial.get(parentGatewaySerial);
    return status != null && TERMINAL_GATEWAY_INVENTORY_STATUSES.has(status);
}
export function getEfemPeripheralReassignState(params) {
    const { parentGatewaySerial, currentGatewaySerial, tenantGatewayStatusBySerial, blockedByLocalDraft, localDraftBlockLabel, } = params;
    if (blockedByLocalDraft) {
        return {
            selectable: false,
            assignmentLabel: localDraftBlockLabel ?? '',
            requiresMoveConfirm: false,
        };
    }
    if (!parentGatewaySerial || parentGatewaySerial === currentGatewaySerial) {
        return { selectable: true, assignmentLabel: '', requiresMoveConfirm: false };
    }
    if (isEfemParentGatewayBindingStale(parentGatewaySerial, tenantGatewayStatusBySerial)) {
        return {
            selectable: true,
            assignmentLabel: ` (was on ${parentGatewaySerial})`,
            requiresMoveConfirm: false,
        };
    }
    return {
        selectable: true,
        assignmentLabel: ` (gateway ${parentGatewaySerial})`,
        requiresMoveConfirm: true,
    };
}
//# sourceMappingURL=efem-peripheral-assignment.utils.js.map